import axios from 'axios'
import commovisconfig from '@/services/config'

//const state = {
//  tenantinfo: {
//    tenantname: null,
//    title: null,
//    details: {
//      Id: null,
//      CId: null
//    },
//    description: null,
//    id: null,
//    redirect: false,
//    primarycolor: null,
//    secondarycolor: null,
//    baseAPI: null,
//    fullURL: null,
//    tenantLogoBase64: null,
//    logo: null,
//    paymentOption: null,
//    userRoleCost: {
//      Participant: null,
//      Facilitator: null,
//      TenantAdmin: null,
//    },
//    euroExchangeRate: null,
//  }
//}

const getDefaultState = () => {
  return {
    tenantinfo: {
      tenantname: null,
      title: null,
      details: {
        Id: null,
        CId: null
      },
      description: null,
      id: null,
      redirect: false,
      b2c: false,
      videoSelfhosting: false,
      companionEnabled: false,
      tasksPageEnabled: false,
      imprintUrl: null,
      dataPrivacyUrl: null,
      primarycolor: null,
      secondarycolor: null,
      baseAPI: null,
      fullURL: null,
      tenantLogoBase64: null,
      logo: null,
      pwa_logo: null,
      paymentOption: null,
      userRoleCost: {
        Participant: null,
        Facilitator: null,
        TenantAdmin: null,
        Observer: null,
      },
      euroExchangeRate: null,
      uiLanguages: ['en'],
    }
  }
};

const state = getDefaultState();

const getters = {

  StateTenant: (state) => state.tenantinfo,

  GetStateTenantColors: (state) => {
    return {
      primaryColor: state.tenantinfo.primarycolor,
      secondaryColor: state.tenantinfo.secondarycolor,
    }
  },

  getPaymentOption: (state) => state.tenantinfo.paymentOption,

  getEuroExchangeRate: (state) => state.tenantinfo.euroExchangeRate,

  isVideoSelfhostingEnabled: (state) => state.tenantinfo.videoSelfhosting === true,

  isCompanionEnabled: (state) => state.tenantinfo.companionEnabled === true,

  isTasksPageEnabled: (state) => state.tenantinfo.tasksPageEnabled === true,

  isB2CTenant: (state) => state.tenantinfo.b2c === true,

  getTenantLegalUrls: (state) => ({
    imprintUrl: state.tenantinfo.imprintUrl || null,
    dataPrivacyUrl: state.tenantinfo.dataPrivacyUrl || null,
  }),

}

const actions = {
  isIP(address) {
    const r = RegExp(
      '^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]).){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$'
    )
    return r.test(address)
  },

  // async createTenant({commit, state, rootState}, payload) {
  //
  //   axios.defaults.baseURL = state.tenantinfo.baseAPI
  //
  //   try {
  //
  //
  //     let config = {
  //       headers: {
  //         Authorization: rootState.auth.bearer
  //       }
  //     };
  //
  //     let payloadAPI = {
  //       "description": payload.description,
  //       "name": payload.name,
  //       "primarycolor": payload.primarycolor,
  //       "secondarycolor": payload.secondarycolor,
  //       "stage": payload.stage,
  //       "title": payload.title,
  //       "logo": payload.logo,
  //       "paymentOption": null,
  //       "userRoleCost": {
  //         Participant: null,
  //         Facilitator: null,
  //         TenantAdmin: null,
  //       },
  //       "euroExchangeRate": null,
  //     }
  //
  //     let response = await axios.post('/tenant', payloadAPI, config);
  //
  //   }
  //   catch (err) {
  //     throw new Error(err);
  //   }
  // },

  // async deleteTenant({ commit, state, rootState }) {
  //
  //   const ID = '';
  //
  //   let config = {
  //     headers: {
  //       Authorization: rootState.auth.bearer
  //     }
  //   }
  //
  //   try {
  //
  //     let response = await axios.delete(`/tenant/${ID}`, config);
  //     console.log(response.data)
  //   }
  //   catch (err) {
  //
  //   }
  // },

  async getTenant({ commit, state, dispatch }) {
    // CRITICAL: Check offline status FIRST, before any network operations
    const isOffline = !navigator.onLine;

    // Helper: compute URLtenantname, URLbaseAPI, URLTenant from current host (same logic for API call)
    const getURLConfig = () => {
      let URLtenantname = commovisconfig.default_tenant;
      let URLbaseAPI = commovisconfig.default_base_api;
      let URLTenant = commovisconfig.dev_stage_URLbase_end;
      if (actions.isIP(window.location.hostname)) {
        URLTenant = 'https://' + URLtenantname + commovisconfig.dev_stage_URLbase_end;
      } else {
        const URLstagename = window.location.host.split('.')[1] ? window.location.host.split('.')[1] : false;
        if (URLstagename === 'dev') {
          URLtenantname = window.location.host.split('.')[1] ? window.location.host.split('.')[0] : false;
          URLbaseAPI = commovisconfig.dev_stage_base_api;
          URLTenant = 'https://' + URLtenantname + commovisconfig.dev_stage_URLbase_end;
        } else {
          URLtenantname = window.location.host.split('.')[1] ? window.location.host.split('.')[0] : false;
          URLbaseAPI = commovisconfig.prod_stage_base_api;
          URLTenant = 'https://' + URLtenantname + commovisconfig.prod_stage_URLbase_end;
        }
      }
      return { URLtenantname, URLbaseAPI, URLTenant };
    };

    const { URLtenantname, URLbaseAPI, URLTenant } = getURLConfig();
    const persistedTenantMatchesHost =
      state.tenantinfo &&
      state.tenantinfo.tenantname &&
      state.tenantinfo.id &&
      URLtenantname &&
      state.tenantinfo.tenantname === URLtenantname;

    // if (!persistedTenantMatchesHost) {
    //   dispatch('journey/clearLastOpenedFullJourney', null, { root: true });
    // }

    // CRITICAL: If tenant info already exists in state (from persistence), use it first and revalidate in background
    // Only when persisted tenant matches current host subdomain (avoid wrong API/tenant after switching URL)
    if (persistedTenantMatchesHost) {
      console.log('Using persisted tenant info from store');
      if (state.tenantinfo.baseAPI) {
        axios.defaults.baseURL = state.tenantinfo.baseAPI;
      }
      if (state.tenantinfo.fullURL) {
        commit('setfullTenantURL', state.tenantinfo.fullURL);
      }
      commit('setTenantAPIurl', state.tenantinfo.baseAPI || commovisconfig.default_base_api);

      if (isOffline) {
        console.log('Offline: Using cached tenant info, skipping API call');
        return state.tenantinfo;
      }

      // Online: return immediately and revalidate in background so bootstrap does not wait
      axios.defaults.baseURL = URLbaseAPI;
      commit('setTenantAPIurl', URLbaseAPI);
      commit('setfullTenantURL', URLTenant);

      axios.post('v2/tenantinfo/' + URLtenantname)
        .then((response) => {
          if (response.data.redirect) {
            location.replace(response.data.redirectUrl || commovisconfig.redirect_tenant_url);
            return;
          }
          commit('setTenant', response.data);
          commit('setTenantAPIurl', URLbaseAPI);
          commit('setfullTenantURL', URLTenant);
        })
        .catch((err) => {
          if (state.tenantinfo && state.tenantinfo.tenantname && state.tenantinfo.baseAPI) {
            console.log('Background tenant revalidate failed, using cached tenant info');
            axios.defaults.baseURL = state.tenantinfo.baseAPI;
          } else {
            console.error('Background tenant revalidate failed:', err);
          }
        });

      return state.tenantinfo;
    }

    // If offline and no cached data, we can't proceed - but try to use what we have
    if (isOffline) {
      if (
        state.tenantinfo &&
        state.tenantinfo.tenantname &&
        URLtenantname &&
        state.tenantinfo.tenantname === URLtenantname
      ) {
        console.log('Offline: No full tenant info, but using partial cached data');
        if (state.tenantinfo.baseAPI) {
          axios.defaults.baseURL = state.tenantinfo.baseAPI;
        }
        return state.tenantinfo;
      }
      console.warn('Offline and no cached tenant info available - app may not function correctly');
      return null;
    }

    // No persisted tenant (or host mismatch): proceed with API call (await)
    axios.defaults.baseURL = URLbaseAPI;
    commit('setTenantAPIurl', URLbaseAPI);
    commit('setfullTenantURL', URLTenant);

    try {
      if (!navigator.onLine) {
        if (state.tenantinfo && state.tenantinfo.tenantname) {
          if (state.tenantinfo.baseAPI) axios.defaults.baseURL = state.tenantinfo.baseAPI;
          return state.tenantinfo;
        }
        return null;
      }

      const response = await axios.post('v2/tenantinfo/' + URLtenantname);
      if (response.data.redirect) {
        location.replace(response.data.redirectUrl || commovisconfig.redirect_tenant_url);
        return response.data;
      }
      commit('setTenant', response.data);
      commit('setTenantAPIurl', URLbaseAPI);
      commit('setfullTenantURL', URLTenant);
      return response.data;
    } catch (err) {
      if (!navigator.onLine && state.tenantinfo && state.tenantinfo.tenantname) {
        if (state.tenantinfo.baseAPI) axios.defaults.baseURL = state.tenantinfo.baseAPI;
        return state.tenantinfo;
      }
      if (state.tenantinfo && state.tenantinfo.tenantname) {
        if (state.tenantinfo.baseAPI) axios.defaults.baseURL = state.tenantinfo.baseAPI;
        return state.tenantinfo;
      }
      console.error('Tenant fetch failed and no cached data available:', err);
      alert(err);
      location.replace(commovisconfig.redirect_tenant_url);
    }
  },

  async update({ commit, state, rootState }, payload) {
    axios.defaults.baseURL = state.tenantinfo.baseAPI

    let config = {
      headers: {
        Authorization: rootState.auth.bearer
      }
    }

    // console.log('tenant id:', state.tenantinfo.id);
    // console.log('payload:', payload);
    // console.log('config:', config);

    try {

      payload.tenantname = state.tenantinfo.tenantname;

      let response = await axios.put(
        'v2/tenant/' + state.tenantinfo.id,
        payload,
        config
      )
      //console.log(response)
      //check if redirect tenant. if yes, redirect with replace

      commit('updateTenant', payload)
      commit('loading/setLoading', false, { root: true })
    } catch (err) {
      commit('loading/setLoading', false, { root: true })
    }
  },

  async setTenantLogo({ commit, dispatch, state, rootState }, payload) {
    axios.defaults.baseURL = rootState.tenant.tenantinfo.baseAPI
    let config = {
      headers: {
        Authorization: rootState.auth.bearer
      }
    };

    const picture_old = state.tenantinfo.logo;

    let payloadAPI = {
      logo: payload.logo,
      tenantname: state.tenantinfo.tenantname,
    }

    try {
      let response = await axios.post('/v2/tenant/update-logo', payloadAPI, config)

      const updatedLogo = response.data.updatedLogo;

      commit('setTenantLogo', updatedLogo.logo);


      if (picture_old !== null) {
        const delete_payload = {
          folder_name: 'tenant_assets',
          file_name: picture_old
        }

        await dispatch('file/deleteFile', delete_payload, {root: true});
      }

      commit('loading/setLoading', false, {
        root: true
      });

      commit('file/setUploadVisible', false, {
        root: true
      });


    } catch (err) {
      alert(err)
    }
  },

  async setTenantPwaLogo({ commit, dispatch, state, rootState }, payload) {
    axios.defaults.baseURL = rootState.tenant.tenantinfo.baseAPI;
    let config = {
      headers: {
        Authorization: rootState.auth.bearer
      }
    };

    const picture_old = state.tenantinfo.pwa_logo;

    let payloadAPI = {
      pwa_logo: payload.pwa_logo,
      tenantname: state.tenantinfo.tenantname
    };

    try {
      let response = await axios.post('/v2/tenant/update-pwa-logo', payloadAPI, config);
      const updatedPwaLogo = response.data.updatedPwaLogo;

      commit('setTenantPwaLogo', updatedPwaLogo.pwa_logo);

      if (picture_old !== null && picture_old !== undefined && picture_old !== '') {
        const delete_payload = {
          folder_name: 'tenant_assets',
          file_name: picture_old
        };
        await dispatch('file/deleteFile', delete_payload, { root: true });
      }

      commit('loading/setLoading', false, { root: true });
      commit('file/setUploadVisible', false, { root: true });
    } catch (err) {
      alert(err);
    }
  },

  async getTenantLogoBase64({ commit, state }) {
    if (!state.tenantinfo.tenantLogoBase64) {
      const logoURL = await this.dispatch('file/getTenantLogoFile');
      const response = await fetch(logoURL);
      const blob = await response.blob();
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64data = reader.result;
        commit('setTenantLogoBase64', base64data);
      };
      reader.readAsDataURL(blob);
    }
  }
  

}

const mutations = {
  setTenant(state, tenantinfo) {
    state.tenantinfo = {
      ...tenantinfo,
      uiLanguages: Array.isArray(tenantinfo.uiLanguages) && tenantinfo.uiLanguages.length
        ? tenantinfo.uiLanguages
        : ['en'],
    }
  },
  updateTenant(state, tenantinfo) {
    state.tenantinfo.title = tenantinfo.title
    state.tenantinfo.description = tenantinfo.description
    state.tenantinfo.primarycolor = tenantinfo.primarycolor
    state.tenantinfo.secondarycolor = tenantinfo.secondarycolor
    if (Object.prototype.hasOwnProperty.call(tenantinfo, 'companionEnabled')) {
      state.tenantinfo.companionEnabled = tenantinfo.companionEnabled === true
    }
    state.tenantinfo.imprintUrl = tenantinfo.imprintUrl || null
    state.tenantinfo.dataPrivacyUrl = tenantinfo.dataPrivacyUrl || null
  },
  setTenantAPIurl(state, baseAPI) {
    //console.log('setTenantAPIurl')
    //console.log(baseAPI)
    state.tenantinfo.baseAPI = baseAPI
  },
  setfullTenantURL(state, fullURL) {
    state.tenantinfo.fullURL = fullURL
  },
  setTenantLogo(state, logo) {
    state.tenantinfo.logo = logo;
  },
  setTenantPwaLogo(state, pwa_logo) {
    state.tenantinfo.pwa_logo = pwa_logo;
  },
  setTenantLogoBase64(state, base64) {
    if (!state.tenantinfo.tenantLogoBase64) {
      state.tenantinfo.tenantLogoBase64 = base64;
    }
  },
  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  },

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}